import React from "react";
import { Heart } from "lucide-react";
import useStore from "../../store/useStore";
import ProductCard from "../product/ProductCard";

const WishlistPage = ({ onViewProduct }) => {
  const wishlist = useStore((state) => state.wishlist);

  return (
    <div className="min-h-screen bg-gradient-to-br from-[#f5f3f9] to-[#e8e4f3] py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="mb-8">
          <h1 className="text-4xl font-serif text-gray-900 mb-2">
            Your Favorites
          </h1>
          <p className="text-gray-600">
            {wishlist.length} {wishlist.length === 1 ? "favorite" : "favorites"}{" "}
            saved for later
          </p>
        </div>

        {wishlist.length === 0 ? (
          <div className="bg-white rounded-3xl shadow-xl p-16 text-center">
            <div className="w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center mx-auto mb-6">
              <Heart className="w-12 h-12 text-gray-400" />
            </div>
            <h2 className="text-2xl font-semibold text-gray-900 mb-4">
              Your favorites list is empty
            </h2>
            <p className="text-gray-600 mb-8">
              Save your favorite items to view them later
            </p>
          </div>
        ) : (
          <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 sm:gap-6">
            {wishlist.map((product) => (
              <ProductCard
                key={product.id}
                product={product}
                onViewDetails={onViewProduct}
              />
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default WishlistPage;
